import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";
import ColorPicker from "../../../../../../themes/Default/components/Form/components/ColorPicker/ColorPicker";
import { groupProgressTestsManagement } from "../../../../../../hooks/api/GroupProgressTestsManagement/GroupProgressTestsManagement";

const AddProgressTest = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const { useAddGroupProgressTestMutation } = groupProgressTestsManagement;
    const [addGroupProgressTest] = useAddGroupProgressTestMutation();

    const tabs = [
        { title: t("plans.title"), onClick: () => gotoPlansTab() },
        { title: t("groupTypes.title"), onClick: () => gotoTypeTab() },
        { title: t("groups.progress"), onClick: () => gotoProgressTab() },
        { title: t("groups.progressTest"), isActive: true },
    ];

    const gotoPlansTab = () => {
        navigate("/settings/groups/plans");
    };

    const gotoTypeTab = () => {
        navigate("/settings/groups/types");
    };

    const gotoProgressTab = () => {
        navigate("/settings/groups/progress");
    };

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        if (values?.contactPerson === "") {
            values.contactPerson = null;
        }
        addGroupProgressTest(values).then((result) => {            
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/groups/progress-tests");
            }
        });
    };

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings/groups/progress-tests" />
                <Button title={t("save")} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("groups.title")} />
                    <Link title={t("groups.progressTest")} />
                    <Link title={t("groups.addTest")} isActive={true} />
                </Breadcrumps>
                <Formik
                        innerRef={formRef}
                        initialValues={{
                            name: ""
                        }}
                        onSubmit={onSaved}
                    >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field isFullWidth={true}>
                                    <Input
                                        name="name"
                                        label={t("noteTypes.name")}
                                        required={true}
                                        value={values.name}
                                        onChange={handleChange}
                                        error={formErrors?.name}
                                    />
                                </Field>      
                            </Row>
                            
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default AddProgressTest;